import React             from 'react';
import validator         from 'validator';
import { Modal }         from 'react-bootstrap';
import { FontAwesomeIcon }   from '@fortawesome/react-fontawesome';
import TextComponent     from './TextComponent';
import TextAreaComponent from './TextAreaComponent';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';

class EmailQuote extends React.Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeNote = this.changeNote.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.validate = this.validate.bind(this);

    this.emailChange = this.emailChange.bind(this);
    this.emailValidate = this.emailValidate.bind(this);
    this.emailBlur = this.emailBlur.bind(this);

    this.partNumberChange = this.partNumberChange.bind(this);
    this.partNumberValidate = this.partNumberValidate.bind(this);
    this.partNumberBlur = this.partNumberBlur.bind(this);

    this.revisionChange = this.revisionChange.bind(this);
    this.revisionValidate = this.revisionValidate.bind(this);
    this.revisionBlur = this.revisionBlur.bind(this);

    this.state = {
      show : false,
      email: Spree.current_user_email || '',
      part_number: props.parameters.part_number || '',
      revision: props.parameters.revision || '',
      note : '',
      disabled: props.quoteStep !== 'QUOTED' && props.quoteStep !== 'PRICE_SELECTED',

      emailError: null,
      emailValid: null,

      partNumberError: null,
      partNumberValid: null,

      revisionError: null,
      revisionValid: null,
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  changeNote(e) {
    this.setState({ note: e.target.value });
  }

  handleSend() {
    if (!this.validate()) {
      return;
    }
    this.props.onSendEmailQuote(
      {
        product_quote_email_request: {
          email: this.state.email,
          part_number: this.state.part_number,
          revision: this.state.revision,
          note : this.state.note,
        },
        product_quote_number       : this.props.parameters.product_quote_number,
      },
      document.getElementsByName('authenticity_token')[0].value,
    );

    this.setState({ show: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quoteStep !== this.props.quoteStep) {
      this.setState({
        disabled: this.props.quoteStep !== 'QUOTED' && this.props.quoteStep !== 'PRICE_SELECTED'
      });
    }

    if (prevProps.parameters.part_number !== this.props.parameters.part_number) {
      this.setState({ part_number: this.props.parameters.part_number });
    }

    if (prevProps.parameters.revision !== this.props.parameters.revision) {
      this.setState({ revision: this.props.parameters.revision });
    }
  }

  validate() {
    let valid = this.emailValidate();
    valid = this.partNumberValidate() && valid;
    return this.revisionValidate() && valid;
  }

  emailChange(e) {
    this.setState({ email: e.target.value });
    if (this.state.emailValid !== null) {
      this.emailValidate(e.target.value);
    }
  }

  emailValidate(email = null) {
    const value = email || this.state.email;
    if (validator.isEmail(value)) {
      this.setState({
        emailError: '',
        emailValid: true,
      });
      return true;
    } else if (value === '') {
      this.setState({
        emailError: 'This field is required',
        emailValid: false,
      });
      return false;
    }
    this.setState({
      emailError: 'Email incorrect',
      emailValid: false,
    });
    return false;
  }

  emailBlur() {
    if (this.state.emailValid === null) {
      return;
    }
    this.emailValidate();
  }

  partNumberChange(e) {
    this.setState({ part_number: e.target.value });
    if (this.state.partNumberValid !== null) {
      this.partNumberValidate(e.target.value);
    }
  }

  partNumberValidate(part_number = null) {
    const value = part_number || this.state.part_number;
    if (validator.isEmpty(value)) {
      this.setState({
        partNumberError: 'This field is required.',
        partNumberValid: false,
      });
      return false;
    } else if (value.length < 3) {
      this.setState({
        partNumberError: 'Please enter at least 3 characters.',
        partNumberValid: false,
      });
      return false;
    }
    this.setState({
      partNumberError: '',
      partNumberValid: true,
    });
    return true;
  }

  partNumberBlur() {
    if (this.state.partNumberValid === null) {
      return;
    }
    this.partNumberValidate();
  }

  revisionChange(e) {
    this.setState({ revision: e.target.value });
    if (this.state.revisionValid !== null) {
      this.revisionValidate(e.target.value);
    }
  }

  revisionValidate(revision = null) {
    const value = revision || this.state.revision;
    if (!validator.isEmpty(value)) {
      this.setState({
        revisionError: '',
        revisionValid: true,
      });
      return true;
    }
    this.setState({
      revisionError: 'This Field is Required',
      revisionValid: false,
    });
    return false;
  }

  revisionBlur() {
    if (this.state.revisionValid === null) {
      return;
    }
    this.revisionValidate();
  }

  render() {
    return (
      <div className="email-quote">
        <button
          type="button"
          className="btn btn-sm btn-primary-clear btn-email-quote ms-2"
          onClick={this.handleShow}
          disabled={this.state.disabled}>
          <FontAwesomeIcon icon={faEnvelope} /> E-mail Quote
        </button>

        <Modal show={this.state.show} onHide={this.handleClose} className="email-quote-modal">
          <Modal.Header closeButton>
            <Modal.Title>Email Quote</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <TextComponent
                  label="Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.emailChange}
                  onBlur={this.emailBlur}
                  data={{ 'data-rule-required': 'true' }}
                  groupName="product_quote_email_request">
                  <label htmlFor="product_quote_email_request[email]" className="error">
                    {this.state.emailError}
                  </label>
                </TextComponent>

              </div>

              <div className="col-md-6">
                <TextComponent
                  label="Part Number"
                  name="part_number"
                  value={this.state.part_number}
                  onChange={this.partNumberChange}
                  onBlur={this.partNumberBlur}
                  data={{ 'data-rule-required': 'true' }}
                  groupName="product_quote_email_request">
                  <label htmlFor="product_quote_email_request[part_number]" className="error">
                    {this.state.partNumberError}
                  </label>
                </TextComponent>

              </div>



              <div className="col-md-6">
                <TextComponent
                  label="Revision"
                  name="revision"
                  value={this.state.revision}
                  onChange={this.revisionChange}
                  onBlur={this.revisionBlur}
                  data={{ 'data-rule-required': 'true' }}
                  groupName="product_quote_email_request">
                  <label htmlFor="product_quote_email_request[revision]" className="error">
                    {this.state.revisionError}
                  </label>
                </TextComponent>

              </div>

              <div className="col-md-12">
                <TextAreaComponent
                  label="Add a Note"
                  name="note"
                  onChange={this.changeNote}
                  value={this.state.note}
                  groupName="product_quote_email_request" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-primary" onClick={this.handleSend}>
              <FontAwesomeIcon icon={faPaperPlane} /> Send Email
            </button>
          </Modal.Footer>
        </Modal>
        {this.props.children}
      </div>
    );
  }
}

export default EmailQuote;
